import { makeStyles } from '@material-ui/core'
// import whatsBackground from '../../assets/wa-background.png'
// import whatsBackgroundDark from '../../assets/wa-background-dark.png'

export const useStyles = makeStyles(theme => ({
  messageContainer: {
    '& a': {
      color: theme.palette.blue_300.main,
      fontWeight: 'bold',
      textDecoration: 'none'
    },
    margin: '2px 10px',
    minWidth: 150,
    maxWidth: 300,
    height: 'auto',
    display: 'block',
    position: 'relative',
    whiteSpace: 'pre-wrap',
    padding: '0 4px 0px',
    boxShadow:
      theme.mode === 'light' ? '0 1px 1px #b3b3b3' : '0 1px 1px #000000',
    transition: 'background-color 0.5s ease-in-out',
    "&:hover [id^='messageActionsButton']": {
      display: 'flex',
      position: 'absolute',
      top: 0,
      right: 0
    }
  },

  messagesListWrapper: {
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    width: '100%',
    minWidth: 300,
    minHeight: 200
  },

  messagesList: {
    // backgroundImage:
    //   theme.mode === 'light'
    //     ? `url(${whatsBackground})`
    //     : `url(${whatsBackgroundDark})`,
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_700.main
        : theme.palette.gray_50.main,

    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    padding: '20px 15px 25px 50px',
    overflowY: 'scroll',
    overflowX: 'hidden',
    ...theme.scrollbarStyles
  },

  circleLoading: {
    color: theme.palette.green_whatsApp.main,
    position: 'absolute',
    opacity: '70%',
    top: 0,
    left: '50%',
    marginTop: 12
  },
  boxMessageLeft: {
    display: 'flex',
    alignItems: 'start',
    justifyContent: 'flex-start'
  },
  contentMessageLeft: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    justifyContent: 'flex-start'
  },

  messageLeft: {
    maxWidth: 600,
    // marginRight: 20,
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_300.main
        : theme.palette.white_100.main,
    color:
      theme.palette.type === 'dark'
        ? theme.palette.white_100.main
        : theme.palette.dark_200.main,
    borderRadius: '0 10px 10px',
    alignSelf: 'flex-start',
    padding: '0 6px 15px 6px',
    '&::before': {
      content: '""',
      position: 'absolute',
      zIndex: 1,
      top: 11,
      left: '-16px',
      borderRadius: '5px',
      width: 0,
      height: 0,
      border: '8px solid transparent',
      borderRight:
        theme.palette.type === 'dark'
          ? `8px solid ${theme.palette.blue_500.main}`
          : `8px solid ${theme.palette.white_100.main}`,
      borderTop:
        theme.palette.type === 'dark'
          ? `8px solid transparent`
          : `8px solid transparent`,
      transform: 'rotate(134deg)',
      transformOrigin: 'top right',
      boxShadow: '-2px 1px 1px rgba(0, 0, 0, 0.02)',
      transition: 'border-color 0.5s ease-in-out'
    }
  },

  quotedContainerLeft: {
    // margin: '-3px -80px 6px -6px',
    overflow: 'hidden',
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_400.main
        : theme.palette.gray_50.main,
    borderRadius: '7.5px',
    display: 'flex',
    width: '100%',
    // position: 'relative',
    cursor: 'pointer'
  },

  quotedMsg: {
    padding: 10,
    // maxWidth: 300,
    width: '100%',
    height: 'auto',
    display: 'block',
    whiteSpace: 'pre-wrap',
    overflow: 'hidden'
  },

  quotedSideColorLeft: {
    flex: 'none',
    width: '4px',
    backgroundColor: '#6bcbef'
  },

  quotedThumbnail: {
    maxWidth: '180px',
    height: '90px'
  },

  boxMessageRight: {
    display: 'flex',
    alignItems: 'start',
    justifyContent: 'flex-end'
  },
  contentMessageRight: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'end',
    justifyContent: 'flex-end'
  },

  messageRight: {
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.green_whatsApp_300.main
        : theme.palette.green_whatsApp_100.main,
    color:
      theme.palette.type === 'dark'
        ? theme.palette.white_100.main
        : theme.palette.dark_200.main,
    // backgroundColor: theme.mode === 'light' ? '#dcf8c6' : '#005c4b',
    // color: theme.mode === 'light' ? '#303030' : '#ffffff',
    alignSelf: 'flex-end',
    borderRadius: '8px 0 8px 8px',
    padding: '0 6px 15px 6px',
    '&::before': {
      content: '""',
      position: 'absolute',

      top: 11,
      right: '1px',
      borderRadius: '5px',
      width: 0,
      height: 0,
      border: '8px solid transparent',
      borderRight:
        theme.palette.type === 'dark'
          ? `8px solid transparent`
          : `8px solid transparent`,
      borderTop:
        theme.palette.type === 'dark'
          ? `8px solid ${theme.palette.green_400.main}`
          : `8px solid ${theme.palette.green_300.main}`,
      transform: 'rotate(134deg)',
      transformOrigin: 'top right',
      boxShadow: '-2px 1px 1px rgba(0, 0, 0, 0.02)',
      transition: 'border-color 0.5s ease-in-out'
    }
  },

  quotedContainerRight: {
    margin: '-3px -80px 6px -6px',
    overflowY: 'hidden',
    backgroundColor: theme.mode === 'light' ? '#cfe9ba' : '#075e54',
    borderRadius: '7.5px',
    display: 'flex',
    position: 'relative'
  },

  quotedMsgRight: {
    padding: 10,
    height: 'auto',
    whiteSpace: 'pre-wrap'
  },

  quotedSideColorRight: {
    flex: 'none',
    width: '4px',
    backgroundColor: '#35cd96'
  },

  messageActionsButton: {
    display: 'flex !important', // Força a visibilidade
    position: 'absolute',
    top: 0,
    right: 0,
    borderTopRightRadius: '10px',
    justifyContent: 'flex-end',
    // position: 'relative',
    border: 'none',
    color: '#999',
    zIndex: 999,
    background:
      theme.palette.type === 'dark'
        ? 'linear-gradient(205deg,rgba(30, 30, 37, .3) 30%, rgba(255, 255, 255, 0) 50%)'
        : 'linear-gradient(205deg,rgba(30, 30, 37, .1) 30%, rgba(255, 255, 255, 0) 50%)',
    width: '42px',
    opacity: '100%',
    '&:hover, &.Mui-focusVisible, & svg': {
      cursor: 'pointer'
    },
    '& svg': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main,
      fontSize: 28
    }
  },

  messageContactName: {
    display: 'flex',
    color: '#6bcbef',
    fontWeight: 500,
    paddingLeft: '4px'
  },

  forwardedMessage: {
    marginTop: 3,
    display: 'flex',
    alignItems: 'center',
    fontStyle: 'italic',
    fontSize: '.75rem',
    gap: '4px',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    '& svg': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main
    }
  },

  forwardedIcon: {
    color: theme.mode === 'light' ? '#999' : '#d0d0d0',
    fontSize: 15,
    verticalAlign: 'middle',
    marginLeft: 4
  },
  textContentItem: {
    marginTop: '12px',
    display: 'flex',
    flexDirection: 'column',
    // alignItems: 'flex-end',
    overflowWrap: 'break-word',
    padding: '6px',
    '& ol': {
      marginLeft: '40px'
    },
    '& .whatsmarked pre': {
      padding: '0',
      backgroundColor: 'transparent'
    }
  },

  textContentItemIsVCard: {
    paddingBottom: '4px',
    margin: 0
  },

  textContentItemDeleted: {
    fontStyle: 'italic',
    color: 'rgba(0, 0, 0, 0.36)',
    overflowWrap: 'break-word',
    padding: '6px'
  },

  textContentItemEdited: {
    overflowWrap: 'break-word',
    padding: '3px 120px 6px 6px'
  },

  messageVideo: {
    width: 250,
    maxHeight: 445,
    borderRadius: 8,
    padding: '0 8px 4px 8px'
  },

  messageMediaSticker: {
    backgroundColor: 'unset',
    boxShadow: 'unset'
  },

  timestamp: {
    fontSize: 10,
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },
  timestampLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    marginLeft: '14px'
  },
  timestampRight: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    marginRight: '14px'
  },

  timestampStickerLeft: {
    backgroundColor: theme.mode === 'light' ? '#ffffff' : '#024481',
    borderRadius: 8,
    padding: 5,
    boxShadow:
      theme.mode === 'light' ? '0 1px 1px #b3b3b3' : '0 1px 1px #000000'
  },

  timestampStickerRight: {
    backgroundColor: theme.mode === 'light' ? '#dcf8c6' : '#128c7e',
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 0,
    paddingLeft: 5,
    paddingRight: 5,
    paddingTop: 5,
    paddingBottom: 0,
    boxShadow:
      theme.mode === 'light' ? '0 1px 1px #b3b3b3' : '0 1px 1px #000000'
  },

  dailyTimestamp: {
    alignItems: 'center',
    textAlign: 'center',
    alignSelf: 'center',
    width: '100px',
    backgroundColor: '#e1f3fb',
    margin: '10px',
    borderRadius: '4px',
    boxShadow: '0 1px 1px #b3b3b3'
  },

  dailyTimestampText: {
    color: '#808888',
    padding: 1,
    alignSelf: 'center',
    marginLeft: '0px'
  },

  ticketDivider: {
    display: 'flex',
    alignItems: 'center',
    margin: '12px 14px',
    color: theme.palette.text.secondary,
    '&::before, &::after': {
      content: '""',
      flex: 1,
      borderTop: `1px solid ${theme.palette.text.secondary}`
    }
  },

  ticketDividerText: {
    padding: '0 8px',
    fontSize: 13
  },

  ackIcons: {
    fontSize: 18,
    verticalAlign: 'middle',
    marginLeft: 4,
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },

  deletedIcon: {
    color: theme.palette.red_100.main
  },

  ackDoneAllIcon: {
    color: theme.palette.green_whatsApp.main,
    fontSize: 18,
    verticalAlign: 'middle',
    marginLeft: 4
  },

  ackDoneReadIcon: {
    color: theme.palette.blue_300.main,
    fontSize: 18,
    verticalAlign: 'middle',
    marginLeft: 4
  },

  messageErrorBand: {
    marginTop: 4,
    marginRight: '12px',
    marginBottom: 2,
    maxWidth: 320,
    overflow: 'hidden',
    backgroundColor: '#c62828',
    color: '#ffeb3b',
    textAlign: 'center',
    padding: '4px 8px',
    borderRadius: 8,
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    lineHeight: 1.3,
    fontWeight: 700,
    alignSelf: 'flex-end'
  },

  downloadMedia: {
    display: 'flex',
    flexDirection: 'column',

    gap: '8px',
    justifyContent: 'center',
    padding: '2px 10px 0px 10px',
    '& a': {
      padding: '6px',
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.white_100.main,
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_400.main
          : theme.palette.gray_400.main
    },
    '& a:hover': {
      color: theme.palette.white_100.main,
      backgroundColor: theme.palette.blue_300.main
    }
  },
  downloadMediaContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '8px'
  },

  downloadMediaInfo: {
    display: 'flex',
    flexDirection: 'column'
  },

  downloadMediaTitle: {
    maxWidth: 170,
    fontSize: '.875rem',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },

  downloadMediaSize: {
    fontSize: '.7rem',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },

  documentIcon: {
    width: 40,
    height: 40,
    objectFit: 'contain'
  },

  imageLocation: {
    position: 'relative',
    width: '100%',
    height: 80,
    borderRadius: 5
  },

  '@global': {
    '@keyframes wave': {
      '0%, 60%, 100%': {
        transform: 'initial'
      },
      '30%': {
        transform: 'translateY(-15px)'
      }
    },
    '@keyframes quiet': {
      '25%': {
        transform: 'scaleY(.6)'
      },
      '50%': {
        transform: 'scaleY(.4)'
      },
      '75%': {
        transform: 'scaleY(.8)'
      }
    },
    '@keyframes normal': {
      '25%': {
        transform: 'scaleY(.1)'
      },
      '50%': {
        transform: 'scaleY(.4)'
      },
      '75%': {
        transform: 'scaleY(.6)'
      }
    },
    '@keyframes loud': {
      '25%': {
        transform: 'scaleY(1)'
      },
      '50%': {
        transform: 'scaleY(.4)'
      },
      '75%': {
        transform: 'scaleY(1.2)'
      }
    }
  },
  messageLeftWave: {
    border: '1xp solid red',
    maxWidth: 600,
    // marginRight: 20,
    backgroundColor: theme.mode === 'light' ? '#ffffff' : '#333653',
    color: theme.mode === 'light' ? '#303030' : '#ffffff',
    borderRadius: '0 10px 10px',
    alignSelf: 'flex-start',
    padding: '10px'
  },
  wave: {
    display: 'flex',
    alignItems: 'center'
    // position: 'relative',
    // textAlign: 'center',
    // height: '30px',
    // marginTop: '10px',
    // marginLeft: 'auto',
    // marginRight: 'auto',
  },
  dot: {
    display: 'inline-block',
    width: '5px',
    height: '5px',
    borderRadius: '50%',
    marginRight: '3px',
    background: theme.palette.blue_300.main,
    animation: 'wave 1.3s linear infinite',
    '&:nth-child(2)': {
      animationDelay: '-1.1s'
    },
    '&:nth-child(3)': {
      animationDelay: '-0.9s'
    }
  },

  wavebarsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    height: '15px',
    marginTop: '5px',
    marginBottom: '5px',
    marginLeft: 'auto',
    marginRight: 'auto',
    '--boxSize': '5px',
    '--gutter': '4px',
    width: 'calc((var(--boxSize) + var(--gutter)) * 5)'
  },

  wavebars: {
    transform: 'scaleY(.4)',
    height: '100%',
    width: 'var(--boxSize)',
    animationDuration: '1.2s',
    backgroundColor: theme.mode === 'light' ? '#303030' : '#ffffff',
    animationTimingFunction: 'ease-in-out',
    animationIterationCount: 'infinite',
    borderRadius: '8px'
  },

  wavebar1: {
    animationName: 'quiet'
  },
  wavebar2: {
    animationName: 'normal'
  },
  wavebar3: {
    animationName: 'quiet'
  },
  wavebar4: {
    animationName: 'loud'
  },
  wavebar5: {
    animationName: 'quiet'
  },
  linkPreviewThumbnail: {
    width: '328px',
    height: '172px'
  },
  linkPreviewTitle: {
    fontWeight: 'bold',
    marginBottom: '4px'
  },
  linkPreviewDescription: {
    marginBottom: '4px'
  },
  linkPreviewUrl: {
    opacity: 0.6
  },
  linkPreviewAnchor: {
    textDecoration: 'none',
    color: theme.mode === 'light' ? '#303030' : '#ffffff'
  },
  messageHighlighted: {
    backgroundColor: theme.palette.blue_300.main
  },
  previewThumbnail: {
    width: '100%',
    maxHeight: '180px',
    objectFit: 'cover',
    marginTop: '5px',
    borderRadius: '8px'
  },
  audioBottom: {
    // marginBottom: '12px'
  },

  messageContainerWithReactions: {
    marginBottom: 35 // Espaço extra quando há reações
  },

  reactionsContainerLeft: {
    position: 'absolute',
    bottom: '-30px',
    left: '10px',
    zIndex: 1
  },

  reactionsContainerRight: {
    position: 'absolute',
    bottom: '-32px',
    right: '10px',
    zIndex: 1
  },

  reactionsLeft: {
    display: 'flex',
    gap: '2px',
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_300.main
        : theme.palette.white_100.main,
    border: '1px solid',
    borderColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_400.main
        : theme.palette.gray_100.main,
    borderRadius: '12px',
    padding: '4px 8px'
  },

  reactionsRight: {
    display: 'flex',
    gap: '2px',
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.green_whatsApp_300.main
        : theme.palette.green_whatsApp_100.main,
    border: '1px solid',
    borderColor:
      theme.palette.type === 'dark'
        ? theme.palette.green_whatsApp_700.main
        : theme.palette.gray_300.main,
    borderRadius: '12px',
    padding: '4px 8px',
    fontFamily: 'Noto Color Emoji, sans-serif'
  },

  reactionItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '2px',
    cursor: 'pointer',
    padding: '2px 4px',
    borderRadius: '10px',
    transition: 'background-color 0.2s',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.05)'
    }
  },

  reactionCount: {
    fontSize: '.75rem',
    fontFamily: 'Inter, sans-serif',
    // fontWeight: '600',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    marginLeft: '2px'
  },

  mediaDescription: {
    padding: 5,
    marginBottom: 5,
    borderLeft: '5px solid',
    borderColor: theme.mode === 'light' ? '#000' : '#fff'
  },

  reactionButton: {
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_400.main
        : theme.palette.white_100.main,
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    width: 30,
    height: 30,
    padding: 6,
    borderRadius: '50%',
    boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.2)',
    '&:hover': {
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_400.main
          : theme.palette.white_100.main,
      color: theme.palette.yellow_400.main
    }
  },

  boxContentMessageInternal: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end'
  },
  boxMessageInternal: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    justifyContent: 'flex-end'
  },
  textContentMesssageInternal: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  messageInternalName: {
    fontWeight: 'bold',
    fontSize: '14px'
  },
  messageInternal: {
    color: theme.palette.dark_700.main,
    backgroundColor: theme.palette.yellow_100.main,
    display: 'flex',
    borderRadius: '8px',
    alignSelf: 'flex-end',
    padding: '0 0 15px 0',
    position: 'relative',
    margin: '5px 20px 5px 20px',
    maxWidth: 350,
    minWidth: 150,
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 11,
      right: '6px',
      borderRadius: '5px',
      width: 0,
      height: 0,
      border: '8px solid transparent',
      borderRight: `8px solid transparent`,
      borderTop: `8px solid ${theme.palette.yellow_100.main}`,
      transform: 'rotate(134deg)',
      transformOrigin: 'top right',
      boxShadow: '-2px 1px 1px rgba(0, 0, 0, 0.02)',
      transition: 'border-color 0.5s ease-in-out'
    }
  },

  messageInternalSystem: {
    backgroundColor: theme.palette.red_50.main,
    '&::before': {
      borderTop: `8px solid ${theme.palette.red_50.main}`
    }
  },

  timestampRightInternal: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    marginRight: '22px'
  },

  // Estilos para o cartão de contato (vCard) - Design idêntico ao WhatsApp
  vCardContainer: {
    maxWidth: '280px',
    minWidth: '240px',
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_400.main
        : theme.palette.white_100.main,
    borderRadius: '12px',
    // boxShadow:
    //   theme.palette.type === 'dark'
    //     ? '0 1px 2px rgba(0, 0, 0, 0.4), 0 1px 3px rgba(0, 0, 0, 0.15)'
    //     : '0 1px 2px rgba(0, 0, 0, 0.12), 0 1px 3px rgba(0, 0, 0, 0.08)',
    // border:
    //   theme.palette.type === 'dark' ? '1px solid' + theme.palette.dark_stroke.main : '1px solid #e1e7ea',
    overflow: 'hidden',
    transition: 'all 0.15s cubic-bezier(0.4, 0.0, 0.2, 1)',
    margin: '4px 0',
    border:
      theme.palette.type === 'dark'
        ? '1px solid' + theme.palette.dark_stroke.main
        : '1px solid' + theme.palette.gray_100.main
  },

  vCardHeader: {
    padding: '16px',
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px'
  },

  vCardAvatar: {
    flexShrink: 0,
    marginTop: '2px'
  },

  vCardInfo: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '6px'
  },

  vCardName: {
    fontWeight: '600',
    fontSize: '1rem',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    margin: '0 !important',
    lineHeight: '20px !important',
    wordBreak: 'break-word',
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical'
  },

  vCardPhoneContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px'
  },

  vCardPhoneIcon: {
    fontSize: '12px',
    opacity: 0.8,
    flexShrink: 0
  },

  vCardPhone: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    fontSize: '13px !important',
    fontFamily: 'inherit !important',
    fontWeight: '400 !important',
    lineHeight: '18px !important'
  },

  vCardDescription: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    fontSize: '13px !important',
    margin: '0 !important',
    lineHeight: '18px !important',
    wordBreak: 'break-word',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical',
    maxHeight: '36px'
  },

  vCardAction: {
    borderTop:
      theme.palette.type === 'dark'
        ? '1px solid' + theme.palette.dark_stroke.main
        : '1px solid' + theme.palette.gray_100.main,
    padding: '0',
    backgroundColor: 'transparent',
    display: 'flex'
  },

  pixCardContainer: {
    marginTop: '6px',
    borderRadius: '10px',
    overflow: 'hidden',
    border:
      theme.palette.type === 'dark'
        ? '1px solid' + theme.palette.dark_stroke.main
        : '1px solid' + theme.palette.gray_stroke.main,
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_400.main
        : theme.palette.white_100.main
  },

  pixCardHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '12px'
  },

  pixCardAction: {
    borderTop:
      theme.palette.type === 'dark'
        ? '1px solid' + theme.palette.dark_stroke.main
        : '1px solid' + theme.palette.gray_100.main,
    display: 'flex'
  },

  pixCardActionButton: {
    width: '100%',
    padding: '11px 16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    backgroundColor: 'transparent',
    transition: 'background-color 0.15s ease',
    cursor: 'pointer',
    border: 'none',
    outline: 'none',
    '&:hover': {
      backgroundColor:
        theme.palette.type === 'dark'
          ? 'rgba(134, 150, 160, 0.1)'
          : 'rgba(17, 27, 33, 0.05)'
    }
  },

  pixCardActionIcon: {
    fontSize: '18px',
    color: '#00a884'
  },

  pixCardActionText: {
    color: '#00a884',
    fontWeight: '600',
    fontSize: '.875rem',
    lineHeight: '20px !important'
  },

  vCardActionButton: {
    width: '100%',
    padding: '12px 16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '6px',
    backgroundColor: 'transparent',
    transition: 'background-color 0.15s ease',
    cursor: 'pointer',
    border: 'none',
    outline: 'none',
    fontFamily: 'inherit',
    '&:hover': {
      backgroundColor:
        theme.palette.type === 'dark'
          ? 'rgba(134, 150, 160, 0.1)'
          : 'rgba(17, 27, 33, 0.05)'
    },
    '&:active': {
      backgroundColor:
        theme.palette.type === 'dark'
          ? 'rgba(134, 150, 160, 0.15)'
          : 'rgba(17, 27, 33, 0.08)'
    }
  },

  vCardActionIcon: {
    fontSize: '14px',
    color: theme.palette.type === 'dark' ? '#00a884' : '#00a884',
    display: 'flex',
    alignItems: 'center'
  },

  vCardActionText: {
    color: theme.palette.blue_300.main,
    fontWeight: '600',
    fontSize: '.875rem',
    lineHeight: '20px !important'
  },

  vCardActionSecondary: {
    borderLeft:
      theme.palette.type === 'dark'
        ? '1px solid' + theme.palette.dark_stroke.main
        : '1px solid' + theme.palette.gray_100.main
  },

  vCardActionTextSecondary: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    fontWeight: '500 !important',
    fontSize: '14px !important',
    lineHeight: '20px !important'
  },

  vCardActionIconSecondary: {
    fontSize: '14px',
    color: theme.palette.type === 'dark' ? '#8696a0' : '#667781',
    display: 'flex',
    alignItems: 'center'
  },

  //events
  // Adicione estas classes no seu objeto useStyles
  systemMsgContainer: {
    display: 'flex',
    justifyContent: 'center',
    margin: '16px 0',
    width: '100%',
    padding: '0 16px',
    boxSizing: 'border-box'
  },
  systemEventPaper: {
    padding: '4px 12px',
    borderRadius: '16px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    border: '1px solid',
    boxShadow: 'none' // Flat design para eventos de sistema
  },
  transferDot: {
    backgroundColor: '#e3f2fd', // Azul muito claro
    borderColor: '#bbdefb',
    color: '#0d47a1' // Contraste alto
  },
  closedDot: {
    backgroundColor: '#ffebee', // Vermelho muito claro
    borderColor: '#ffcdd2',
    color: '#b71c1c'
  },
  historyDot: {
    backgroundColor: '#e8f5e9', // Verde muito claro
    borderColor: '#c8e6c9',
    color: '#1b5e20'
  },
  noteDot: {
    backgroundColor: '#fff8e1', // Amarelo/Âmbar muito claro
    borderColor: '#ffecb3',
    color: '#f57f17'
  },
  manualDot: {
    backgroundColor: '#f5f5f5', // Cinza muito claro
    borderColor: '#e0e0e0',
    color: '#424242'
  },

  linkPreviewContainer: {
    overflow: 'hidden',
    backgroundColor:
      theme.palette.type === 'dark'
        ? 'rgba(0, 0, 0, 0.15)'
        : 'rgba(0, 0, 0, 0.05)',
    borderRadius: '7.5px',
    display: 'flex',
    width: '100%',
    maxWidth: '100%',
    maxHeight: '100px', // Evita que o container cresça demais verticalmente
    cursor: 'pointer',
    marginTop: '4px',
    borderLeft: `4px solid ${theme.palette.blue_300.main}`
  },

  linkPreviewMsg: {
    padding: '8px',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  },

  linkPreviewTitle: {
    fontWeight: 'bold',
    fontSize: '0.9rem',
    marginBottom: '2px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },

  linkPreviewDescription: {
    fontSize: '0.8rem',
    opacity: 0.8,
    marginBottom: '2px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },

  linkPreviewUrl: {
    fontSize: '0.75rem',
    opacity: 0.5,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },

  linkPreviewThumbnail: {
    width: '90px',
    height: '100px',
    objectFit: 'cover',
    flexShrink: 0
  },

  linkPreviewAnchor: {
    textDecoration: 'none',
    width: '100%',
    display: 'block',
    color: 'inherit' // Herda a cor do texto do balão de mensagem atual (claro/escuro)
  },

  audioMessageWrapper: {
    maxWidth: '350px'
  },
  transcriptionToggleButton: {
    backgroundColor: theme.palette.green_whatsApp_300.main,
    color: theme.palette.white_100.main,
    padding: '2px 6px',
    '& span': {
      fontSize: '.7rem',
      display: 'flex',
      alignItems: 'center',
      gap: '4px'
    },
    '&:hover': {
      backgroundColor: theme.palette.green_whatsApp_700.main
    }
  },
  transcriptionContent: {
    borderRadius: '8px',
    marginTop: '4px',
    padding: '2px 6px',
    background: theme.palette.green_whatsApp_100.main,
    '& .whatsmarked p': {
      margin: '6px 6px 0 6px ',
      color: theme.palette.green_whatsApp_700.main
    }
  }
}))
